export const footerStyle = {
  background: "#1C104F",
  height: "345px",
};

export const footerAdress = {
  color: "#4B3A8E",
  paddingTop: "57.9px",
  fontWeight: "600",
  fontSize: "12px",
  fontFamily: "AppRegular",
};

export const footerLinkStyle = {
  color: "#C4D0FB",
  fontFamily: "AppRegular",
  fontWeight: "500",
  fontSize: "14px",
  lineHeight: "17px",
  textDecoration: "none",
};

export const footerAccountButton = {
  textTransform: "none",
  border: "1px solid #1D4CF2",
  borderRadius: "8px",
  color: "#1D4CF2",
  fonrFamily: "AppRegular",
  fontWeight: "600",
  fontSize: "14px",
};

export const footerSanly = {
  color: "#C4D0FB",
  fontFamily: "AppRegular",
  fontWeight: "500",
  fontSize: "14px",
};

export const iconButtonStyleFooter = {
  color: "#C4D0FB",
  border: "1px solid #332374",
  background: "#0F0730",
  width: "50px",
  height: "50px",
  borderRadius: "10px",

  "&:hover": {
    color: "#1D4CF2",
  },
};
